/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * userAndPermissionApi API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';

import type { ApiResponseMenuHistoryResponse } from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getMenuHistory
 */
export const getV11HistoryMenu = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponseMenuHistoryResponse>(
    { url: `/api/v11/history/menu`, method: 'GET', signal },
    options,
  );
};

export const getGetV11HistoryMenuQueryKey = () => {
  return ['api', 'v11', 'history', 'menu'] as const;
};

export const getGetV11HistoryMenuQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11HistoryMenu>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV11HistoryMenu>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11HistoryMenuQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11HistoryMenu>>> = ({ signal }) =>
    getV11HistoryMenu(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11HistoryMenu>>,
    TError,
    TData
  >;
};

export type GetV11HistoryMenuQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11HistoryMenu>>
>;
export type GetV11HistoryMenuQueryError = ErrorType<unknown>;

/**
 * @summary getMenuHistory
 */

export function useGetV11HistoryMenu<
  TData = Awaited<ReturnType<typeof getV11HistoryMenu>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV11HistoryMenu>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11HistoryMenuQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
